export default class User {

    constructor()
    {
        this.user = JSON.parse(localStorage.getItem('user')) || [];
    }

    set(user) {
        this.user = user;
    }

    get() {
        return this.user;
    }

    inDepartmentById(departmentId) {
        if (this.inArrayField(departmentId, this.user.departments, 'id')) {
            return true;
        } else {
            return false;
        }
    }

    inArray(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }
        return false;
    }

    inArrayField(needle, haystack, field) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i][field] == needle) return true;
        }
        return false;
    }

}
